import { observable } from "mobx";
import { ID } from "@closerplatform/closer-sdk/dist/protocol/protocol";
import { ChatStore } from "./chatStore";
import { IForeSpinnerService } from "../services/spinnerService";
import { IUserService } from "@fidget/common/services/userService";

export interface IRoomState {
  chat: ChatStore;
  oldestTimestamp?: number;
  historyIsFullyLoaded: boolean;
  marks: Map<ID, number>;
  usersTyping: Array<ID>;
  isLoading: boolean;
  isReloading: boolean;
}

export abstract class AbstractRoomState {
  readonly chat: ChatStore;
  oldestTimestamp?: number;
  historyIsFullyLoaded: boolean;
  readonly marks: Map<ID, number>;
  @observable readonly usersTyping: Array<ID>;
  @observable isLoading: boolean;
  isReloading: boolean;

  protected constructor(userService: IUserService, spinnerService: IForeSpinnerService) {
    this.chat = new ChatStore(userService, spinnerService);
    this.marks = new Map();
    this.usersTyping = [];
    this.isLoading = true;
    this.historyIsFullyLoaded = false;
    this.isReloading = false;
  }
}
